export { OpenAICompatibleChatLanguageModel } from './chat/openai-compatible-chat-language-model';
export type {
  OpenAICompatibleChatModelId,
  OpenAICompatibleLanguageModelChatOptions,
  /** @deprecated Use `OpenAICompatibleLanguageModelChatOptions` instead. */
  OpenAICompatibleLanguageModelChatOptions as OpenAICompatibleProviderOptions,
} from './chat/openai-compatible-chat-options';
export { OpenAICompatibleCompletionLanguageModel } from './completion/openai-compatible-completion-language-model';
export type {
  OpenAICompatibleCompletionModelId,
  OpenAICompatibleLanguageModelCompletionOptions,
  /** @deprecated Use `OpenAICompatibleLanguageModelCompletionOptions` instead. */
  OpenAICompatibleLanguageModelCompletionOptions as OpenAICompatibleCompletionProviderOptions,
} from './completion/openai-compatible-completion-options';
export { OpenAICompatibleEmbeddingModel } from './embedding/openai-compatible-embedding-model';
export type {
  OpenAICompatibleEmbeddingModelId,
  OpenAICompatibleEmbeddingModelOptions,
  /** @deprecated Use `OpenAICompatibleEmbeddingModelOptions` instead. */
  OpenAICompatibleEmbeddingModelOptions as OpenAICompatibleEmbeddingProviderOptions,
} from './embedding/openai-compatible-embedding-options';
export { OpenAICompatibleImageModel } from './image/openai-compatible-image-model';
export type {
  OpenAICompatibleErrorData,
  ProviderErrorStructure,
} from './openai-compatible-error';
export type { MetadataExtractor } from './chat/openai-compatible-metadata-extractor';
export { createOpenAICompatible } from './openai-compatible-provider';
export type {
  OpenAICompatibleProvider,
  OpenAICompatibleProviderSettings,
} from './openai-compatible-provider';
export { VERSION } from './version';
